import { FC } from "react";
import Select from "react-select";
import { useI18n } from "../../hooks/useTranslations";
import { Currency, getCurrencies } from "../../types";
import Numeric from "../ui/Numeric";
import reactSelectStyles from "../ui/ReactSelectUtils";
import styles from "./CostInput.module.css";

type CostInputProps = {
  isDisabled?: boolean;
  isLoading?: boolean;
  id: string;
  costNet?: number | null;
  costGross?: number | null;
  currency?: Currency | null;

  // funzioni da chiamare quando cambiano i valori
  onSetCostNet: (value: number | null) => void;
  onSetCostGross?: (value: number | null) => void;
  onSetCurrency: (value: Currency | null) => void;

  isGrossInvalid?: boolean;
  isNetInvalid?: boolean;
  isCurInvalid?: boolean;

  onlyCostNet?: boolean;
};

const CostInput: FC<CostInputProps> = ({
  isDisabled,
  isLoading,
  id,
  costNet,
  costGross,
  currency,

  onSetCostNet,
  onSetCostGross,
  onSetCurrency,

  isGrossInvalid,
  isNetInvalid,
  isCurInvalid,

  onlyCostNet,
}) => {
  const i18n = useI18n();
  const currencies = getCurrencies();

  return (
    <div className={styles["cost-row"]}>
      <Numeric
        id={`${id}_net`}
        value={costNet}
        onBlur={onSetCostNet}
        decimalScale={2}
        suffix={currency ? ` ${currency.symbol}` : undefined}
        disabled={isDisabled || isLoading}
        allowNegative={false}
        isInvalid={isNetInvalid}
      />
      {!onlyCostNet && (
        <Numeric
          id={`${id}_gross`}
          value={costGross}
          onBlur={onSetCostGross}
          decimalScale={2}
          suffix={currency ? ` ${currency.symbol}` : undefined}
          disabled={isDisabled || isLoading}
          allowNegative={false}
          isInvalid={isGrossInvalid}
        />
      )}
      <div className={styles["select"]}>
        <Select
          menuPosition="fixed"
          id={`${id}_currency`}
          options={currencies}
          value={currency}
          isLoading={isLoading}
          isDisabled={isDisabled || isLoading}
          placeholder={`${i18n.t.common.select}...`}
          getOptionLabel={(x) => x.label}
          getOptionValue={(x) => x.value}
          onChange={onSetCurrency}
          isClearable
          styles={reactSelectStyles<Currency>(isCurInvalid)}
        />
      </div>
    </div>
  );
};

export default CostInput;
